// index.jsx
import React, { useState, useEffect } from "react";
import { Box, TableContainer, Paper, Table, TableBody } from "@mui/material";
import TableHeader from "./TableHeader";
import TableRowItem from "./TableRowItem";
import DetailsModal from "./DetailsModal";
import api from "../../../../services/api";

const StandardCakesTable = ({ standardCakes, onEdit, onDelete }) => {
  const [sizeOptions, setSizeOptions] = useState([]);
  const [flavorOptions, setFlavorOptions] = useState([]);
  const [icingOptions, setIcingOptions] = useState([]);
  const [selectedCake, setSelectedCake] = useState(null);
  const [detailsModalOpen, setDetailsModalOpen] = useState(false);

  useEffect(() => {
    fetchOptions();
  }, []);

  const fetchOptions = async () => {
    try {
      const [sizes, flavors, icings] = await Promise.all([
        api.get("/sizes"),
        api.get("/flavors"),
        api.get("/icings"),
      ]);
      setSizeOptions(sizes.data);
      setFlavorOptions(flavors.data);
      setIcingOptions(icings.data);
    } catch (error) {
      console.error("Error fetching options:", error);
    }
  };

  const handleOpenDetailsModal = (cake) => {
    setSelectedCake(cake);
    setDetailsModalOpen(true);
  };

  return (
    <>
      <Box sx={{ width: "100%", overflowX: "auto" }}>
        <TableContainer component={Paper} sx={{ width: "100%" }}>
          <Table size="small" stickyHeader>
            <TableHeader />
            <TableBody>
              {standardCakes.map((cake) => (
                <TableRowItem
                  key={cake._id}
                  cake={cake}
                  flavorOptions={flavorOptions}
                  icingOptions={icingOptions}
                  sizeOptions={sizeOptions}
                  onEdit={onEdit}
                  onDelete={onDelete}
                  onMoreInfo={handleOpenDetailsModal}
                />
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Box>

      {selectedCake && (
        <DetailsModal
          open={detailsModalOpen}
          onClose={() => setDetailsModalOpen(false)}
          cake={selectedCake}
          flavorOptions={flavorOptions}
          icingOptions={icingOptions}
        />
      )}
    </>
  );
};

export default StandardCakesTable;
